import { API } from "services/api";

export type MetodoRecarga = "PIX" | "CREDIT_CARD";

export type PagamentoCarteira = {
  id: number;
  finalidade: "recarga" | "cotacao";
  metodo: MetodoRecarga;
  valor: number;
  taxa: number;
  total: number;
  status: "PENDING" | "PAGO" | "ESTORNADO" | "FALHOU" | "CANCELADO";
  invoice_url: string | null;
  pix_copia_cola: string | null;
  pix_expira_em: string | null;
  pix_imagem?: string | null;
  criado_em: string;
  pago_em: string | null;
};

export type LancamentoCarteira = {
  id: number;
  tipo: "recarga" | "debito_envio" | "estorno" | "estorno_envio" | "ajuste";
  valor: number;
  descricao: string | null;
  criado_em: string;
};

export type ResumoCarteira =
  | { ok: true; habilitada: false }
  | {
      ok: true;
      habilitada: true;
      saldo: number;
      limites: { minimo: number; maximo: number };
      taxa_cartao_pct_efetiva: number;
      lancamentos: LancamentoCarteira[];
      pendentes: PagamentoCarteira[];
    };

export const getCarteira = async () => (await API.get<ResumoCarteira>("/api/carteira")).data;

export const previewTaxaCartao = async (valor: number) =>
  (
    await API.get<{ ok: boolean; valor: number; taxa: number; total: number }>("/api/carteira/taxa-cartao", {
      params: { valor },
    })
  ).data;

export const criarRecarga = async (valor: number, metodo: MetodoRecarga) =>
  (await API.post<{ ok: boolean; pagamento: PagamentoCarteira }>("/api/carteira/recargas", { valor, metodo })).data;

export const consultarRecarga = async (id: number) =>
  (await API.get<{ ok: boolean; pagamento: PagamentoCarteira; saldo: number }>(`/api/carteira/recargas/${id}`)).data;

// O modal da carteira vive no AppSidebar e o saldo aparece no Header: os dois
// conversam por eventos de janela em vez de levantar estado para o layout.
const EVENTO_ABRIR = "intrex:carteira-abrir";
const EVENTO_ATUALIZADA = "intrex:carteira-atualizada";

export const abrirCarteira = () => window.dispatchEvent(new Event(EVENTO_ABRIR));
export const avisarCarteiraAtualizada = () => window.dispatchEvent(new Event(EVENTO_ATUALIZADA));

export const aoAbrirCarteira = (fn: () => void) => {
  window.addEventListener(EVENTO_ABRIR, fn);
  return () => window.removeEventListener(EVENTO_ABRIR, fn);
};

export const aoAtualizarCarteira = (fn: () => void) => {
  window.addEventListener(EVENTO_ATUALIZADA, fn);
  return () => window.removeEventListener(EVENTO_ATUALIZADA, fn);
};
